import React from 'react';

import VmSupplierManager from '../components/vm-supplier/manager';

export default class VmSupplierPage extends React.Component{
	render(){
		return (
			<div style={{ margin: 16 }}>
				<VmSupplierManager/>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/containers/vm-supplier-page.js